export default __webpack_public_path__ + "locales/about.bua.json";